/**
 * Strip HTML tags and convert to plain text with newlines.
 */
function stripHtml(html) {
    return html
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<\/(strong|b|h[1-6])>/gi, '\n')
        .replace(/<p[^>]*>/gi, '')
        .replace(/<[^>]+>/g, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
}

/**
 * Truncate text to maxLength, appending '...' if truncated.
 */
function truncateText(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}

/**
 * Fast UGC Video Sharing - Create viral content automatically
 * @param action - jQuery element for share buttons
 */
export function shareMessage(action) {
    action.click(function (event) {
        event.preventDefault();

        // Initialize modal on first load when clicked
        initializeSocialShareModal();

        // Extract assistant message text
        const messageContainer = $(this).closest('.g-chatform-message');
        const contentEl = messageContainer.find('.g-chatform-message-content-inner');
        let messageText = '';
        if (contentEl.length > 0) {
            // Clone and remove quiz/widget elements before extracting text
            const cleanedEl = contentEl.clone();
            cleanedEl.find('.growtype-quiz-wrapper, .g-chatform-message-assets-wrapper').remove();
            const rawHtml = cleanedEl.html() || '';
            console.log('[shareMessage] rawHtml length:', rawHtml.length, 'preview:', rawHtml.substring(0, 200));
            messageText = stripHtml(rawHtml);
            console.log('[shareMessage] extracted messageText:', messageText.substring(0, 200));
        } else {
            messageText = messageContainer.text().trim();
            console.log('[shareMessage] fallback messageText:', messageText.substring(0, 200));
        }

        // Retrieve previous message (what user asked)
        let userMessageText = '';
        let prevMsgEl = messageContainer.prevAll('.g-chatform-message:visible').first();
        if (prevMsgEl.length === 0) {
            prevMsgEl = messageContainer.prevAll('.g-chatform-message').not('[style*="display:none"]').not('[style*="display: none"]').first();
        }
        if (prevMsgEl.length > 0) {
            const userContentEl = prevMsgEl.find('.g-chatform-message-content-inner');
            if (userContentEl.length > 0) {
                userMessageText = stripHtml(userContentEl.html() || '');
            } else {
                userMessageText = prevMsgEl.text().trim();
            }
        }
        // Truncate long messages for share card display
        userMessageText = truncateText(userMessageText, 200);
        messageText = truncateText(messageText, 400);

        const messageRole = messageContainer.attr('data-role');

        // Extract conversation title / chat name if available
        let conversationTitle = $('.roleplay-title').first().text().trim() ||
            $('.g-chatform-header-users-single p').first().text().trim() ||
            $('.g-chatprofile-name .e-title').first().text().trim() ||
            '';

        // Get character image from profile avatar
        let characterImage = $('.g-chatprofile-avatar').find('a:first').attr('href');
        if (!characterImage) {
            characterImage = messageContainer.find('.g-chatform-header-users-single-img img').attr('src') ||
                $('.g-chatform-header-users-single-img img').first().attr('src');
        }

        // Check if message contains a video
        let messageVideo = messageContainer.find('.g-chatform-message-assets-wrapper video source').attr('src');

        // Try alternative selector if not found
        if (!messageVideo) {
            messageVideo = messageContainer.find('.video-wrapper video source').attr('src');
        }

        // Remove the #t=0.1 fragment if present
        if (messageVideo) {
            messageVideo = messageVideo.split('#')[0];
        }

        const shareDetails = growtype_chat_ajax.share_modal_details || {};
        const mainLogo = shareDetails.main_logo || {
            url: shareDetails.main_logo_url || '',
            width: shareDetails.main_logo_width || '',
            height: shareDetails.main_logo_height || '',
            position: 'top',
        };
        const logoUrl = mainLogo.url || shareDetails.main_logo_url || '';
        const cta = shareDetails.cta || {
            text: shareDetails.cta_text || '',
            position: 'bottom',
            font_size: 44,
            font_family: shareDetails.secondary_font_family || 'Inter, sans-serif',
        };
        const ctaText = cta.text || shareDetails.cta_text || '';
        const mainTextDetails = shareDetails.main_text || { position: 'center', color: '#ffffff', text_shadow: false };
        const background = shareDetails.background || { color: shareDetails.background_color || '#ff9000' };

        // Use character image as background if available
        if (characterImage) {
            background.image = characterImage;
        }
        const backgroundColor = background.color || shareDetails.background_color || '#ff9000';
        const textColor = mainTextDetails.color || mainTextDetails.text_color || shareDetails.text_color || '#ffffff';
        const textShadow = (mainTextDetails.text_shadow !== undefined ? mainTextDetails.text_shadow : shareDetails.text_shadow) !== false;
        const styles = shareDetails.styles || [];

        // Store message data using canonical structure
        window.currentShareData = {
            values: {
                logo: { url: logoUrl, width: mainLogo.width || 360, height: mainLogo.height || null },
                title: conversationTitle,
                intro_message: userMessageText,
                answer: messageText,
                outro_text: ctaText,
                domain: window.location.hostname.replace('www.', ''),
            },
            elements: shareDetails.elements || null,  // null = use default from get_share_data_structure
            card: shareDetails.card || { width: 1080, height: 1920 },
            background: background,
            text_color: textColor,
            style: styles.find(s => s.is_default) || (styles.length > 0 ? styles[0] : null),
        };

        // Show the social share modal and start generation
        showSocialShareModal();
        generateAndShowVideo();
    });
}

/**
 * Initialize and inject the social share modal into the DOM
 */
function initializeSocialShareModal() {
    // Check if modal already exists
    if ($('#socialShareModal').length > 0) {
        return;
    }

    // Create modal HTML
    const modalHTML = `
        <div id="socialShareModal" class="social-share-modal" style="display: none;">
            <div class="social-share-overlay"></div>
            <div class="social-share-content">
                <div class="social-share-header">
                    <h3>Share content</h3>
                    <button class="social-share-close">&times;</button>
                </div>
                <div class="social-share-body">
                    <div class="generation-status">
                        <div class="spinner"></div>
                        <p>Generating content...</p>
                    </div>
                    <div class="video-container" style="display: none;">
                        <video id="generatedVideo" controls playsinline style="width: 100%; max-width: 300px; border-radius: 10px;">
                            <source id="videoSource" type="video/webm">
                        </video>
                    </div>
                    <div class="image-preview-container" style="display: none;">
                        <img id="generatedImage" src="" style="width: 100%; max-width: 400px; border-radius: 12px;" alt="Share preview" />
                    </div>
                    <div class="style-selector" style="display: none;">
                        <label>Style</label>
                        <div class="style-options"></div>
                    </div>
                    <div class="social-icons-grid" style="display: none;">
                        <button class="social-icon-btn" data-platform="tiktok" style="display:none">
                            <svg viewBox="0 0 24 24" width="20" height="20">
                                <path fill="currentColor" d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                            </svg>
                            <span>TikTok</span>
                        </button>
                        <button class="social-icon-btn" data-platform="instagram" style="display:none">
                            <svg viewBox="0 0 24 24" width="20" height="20">
                                <path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"/>
                            </svg>
                            <span>Instagram</span>
                        </button>
                        <button class="social-icon-btn" data-platform="twitter" style="display:none">
                            <svg viewBox="0 0 24 24" width="20" height="20">
                                <path fill="currentColor" d="M22.46 6c-.85.38-1.78.64-2.75.76a4.8 4.8 0 0 0 2.1-2.66c-.92.55-1.95.95-3.04 1.17a4.77 4.77 0 0 0-8.13 4.35A13.54 13.54 0 0 1 3.8 4.62a4.77 4.77 0 0 0 1.48 6.37 4.73 4.73 0 0 1-2.16-.6v.06c0 2.31 1.64 4.24 3.82 4.68a4.76 4.76 0 0 1-2.15.08 4.78 4.78 0 0 0 4.46 3.32A9.57 9.57 0 0 1 2 19.54a13.5 13.5 0 0 0 7.29 2.14c8.75 0 13.54-7.25 13.54-13.54 0-.21 0-.41-.01-.61A9.66 9.66 0 0 0 24 4.56a9.43 9.43 0 0 0-2.54.7z"/>
                            </svg>
                            <span>Twitter/X</span>
                        </button>
                        <button class="social-icon-btn" data-platform="facebook" style="display:none">
                            <svg viewBox="0 0 24 24" width="20" height="20">
                                <path fill="currentColor" d="M12 2.04c-5.5 0-10 4.49-10 10.02 0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z"/>
                            </svg>
                            <span>Facebook</span>
                        </button>
                        <button class="social-icon-btn" data-platform="download">
                            <svg viewBox="0 0 24 24" width="20" height="20">
                                <path fill="currentColor" d="M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"/>
                            </svg>
                            <span>Download</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `;

    // Inject modal into body
    $('body').append(modalHTML);

    // Inject styles
    injectModalStyles();

    // Bind event handlers
    bindModalEvents();
}

/**
 * Show the social share modal
 */
function showSocialShareModal() {
    $('#socialShareModal').fadeIn(300);
    $('body').css('overflow', 'hidden');

    // Reset state
    $('.generation-status').show();
    $('.video-container').hide();
    $('.image-preview-container').hide();
    $('.social-icons-grid').hide();
    $('.style-selector').hide();
}

/**
 * Hide the social share modal
 */
function hideSocialShareModal() {
    $('#socialShareModal').fadeOut(300);
    $('body').css('overflow', '');

    // Clean up preview
    const img = document.getElementById('generatedImage');
    if (img) {
        img.src = '';
    }
}

/**
 * Bind modal event handlers
 */
function bindModalEvents() {
    // Close button
    $('.social-share-close, .social-share-overlay').click(function () {
        hideSocialShareModal();
    });

    // Social platform buttons
    $('.social-icon-btn').click(function () {
        const platform = $(this).attr('data-platform');
        handleSocialShare(platform);
    });
}

/**
 * Generate and show share content using html2canvas (HTML/CSS → Image).
 */

/**
 * Load a Google Font by family name so html2canvas can render it.
 * Uses the Font Loading API with a Promise-based timeout fallback.
 */
function loadGoogleFont(fontFamily) {
    return new Promise((resolve) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}&display=swap`;
        link.onload = () => resolve();
        link.onerror = () => resolve(); // proceed even if font fails
        document.head.appendChild(link);
        // Timeout fallback — don't block if fonts.googleapis.com is unreachable
        setTimeout(resolve, 3000);
    });
}

async function generateAndShowVideo() {
    try {
        const data = window.currentShareData || {};
        console.log('[shareCard] values:', JSON.parse(JSON.stringify(data.values || {})));
        console.log('[shareCard] bg:', data.background?.color, 'txt:', data.text_color);
                console.log('[shareCard] data.style keys:', data.style ? Object.keys(data.style) : 'null/undefined');
                console.log('[shareCard] data.style.main_text:', JSON.parse(JSON.stringify(data.style?.main_text || {})));

        // Load Google Font if specified in the style preset
        const googleFont = data.style?.main_text?.google_font;
        if (googleFont) {
            console.log('[shareCard] loading font:', googleFont);
            await loadGoogleFont(googleFont);
        }

        // 1. Load html2canvas dynamically (version-pinned CDN)
        await loadHtml2Canvas();

        // 2. Build share card HTML
        const cardHtml = buildShareCard(data);

        // 3. Append card to DOM (hidden)
        const wrapper = document.createElement('div');
        wrapper.id = 'share-card-temp';
        wrapper.style.cssText = 'position:fixed;top:-9999px;left:-9999px;';
        wrapper.innerHTML = cardHtml;
        document.body.appendChild(wrapper);

        // 4. Wait for images to load (not arbitrary timeout)
        const cardEl = wrapper.firstElementChild;
        await waitForImages(cardEl);

        // 5. Capture to blob (scale 1 = 1080×1920, JPEG ~800KB vs PNG ~3MB)
        const blob = await window.captureElementToBlob(cardEl, { scale: 1, mimeType: 'image/jpeg', quality: 0.92 });
        const imageUrl = URL.createObjectURL(blob);

        // 6. Clean up temp DOM
        document.body.removeChild(wrapper);

        // Hide loading
        $('.generation-status').hide();

        // Show generated image
        $('.image-preview-container').show().find('img').attr('src', imageUrl);

        $('.social-icons-grid').show();

        // If only one button is visible, make it full width
        const visibleBtns = $('.social-icon-btn:visible').length;
        if (visibleBtns === 1) {
            $('.social-icons-grid').addClass('single-button');
        }

        // Render style selector
        renderStyleOptions();

        // Store for sharing/download
        window.currentShareImageUrl = imageUrl;
        window.currentShareBlob = blob;

        // Upload to backend for permanent URL (fire-and-forget with error handling)
        uploadShareImage(blob);

    } catch (error) {
        console.error('Error generating content:', error);
        $('.generation-status').html(`<p style="color: red;">Failed to generate media: ${error.message || 'Unknown error'}. Please try again.</p>`);
    }
}

/**
 * Wait for all images within an element to load (with timeout fallback).
 */
function waitForImages(element, timeoutMs = 8000) {
    const images = element.querySelectorAll('img');
    if (images.length === 0) return Promise.resolve();

    const loadPromises = Array.from(images).map(img => {
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();
        return new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = resolve; // Don't block on broken images
        });
    });

    return Promise.race([
        Promise.all(loadPromises),
        new Promise(resolve => setTimeout(resolve, timeoutMs)),
    ]);
}

/**
 * Dynamically load html2canvas from CDN (once).
 */
let _html2canvasLoaded = false;
function loadHtml2Canvas() {
    return new Promise((resolve, reject) => {
        if (_html2canvasLoaded && window.html2canvas) return resolve();
        const script = document.createElement('script');
        script.src = 'https://html2canvas.hertzen.com/dist/html2canvas.min.js'; // @1.4.1
        script.onload = () => { _html2canvasLoaded = true; resolve(); };
        script.onerror = () => reject(new Error('Failed to load html2canvas'));
        document.head.appendChild(script);
    });
}

/**
 * Build an HTML/CSS share card for html2canvas capture.
 * This is where you customize the card design with CSS.
 */
/**
 * Scale font size down for long text to fit within the card's available height.
 * Card is 1920px tall; ~1000px available for text after header/footer.
 * At line-height 1.35, each line takes fontSize * 1.35 px.
 */
function scaleFontToFit(text, baseFontSize) {
    const cardHeight = (window.currentShareData?.card?.height) || 1920;
    const available = cardHeight * 0.48;
    const lineHeight = 1.35;
    const avgCharsPerLine = 33;
    const lines = text.split('\n');
    let totalLines = 0;
    lines.forEach(line => {
        totalLines += Math.max(1, Math.ceil(line.length / avgCharsPerLine));
    });
    const needed = totalLines * baseFontSize * lineHeight;
    if (needed <= available) return baseFontSize;
    return Math.max(26, Math.round(baseFontSize * (available / needed)));
}

/**
 * Build share card HTML from declarative elements array.
 *
 * The `elements` array is the single source of truth for layout.
 * Add/remove/reorder elements in PHP config — no JS changes needed.
 *
 * Supported types: text, image, divider
 */
function buildShareCard(data) {
    const values = data.values || {};
    // Use custom elements from data, or fall back to backend defaults
    const elements = data.elements || growtype_chat_ajax?.share_modal_details?.elements || [];
    const cardCfg = data.card || {};
    const width = cardCfg.width || 1080;
    const height = cardCfg.height || 1920;
    const bgColor = data.background?.color || '#ff9000';
    const bgImage = data.background?.image;
    const txtColor = data.text_color || '#ffffff';
    const style = data.style || {};
    const fontFamily = style.main_text?.font_family || 'Inter, sans-serif';

    // Generic element renderer — add new types here
    const renderers = {
        image(el) {
            const v = values[el.key] || {};
            const s = el.style || {};
            if (!v.url) return '';
            return `<div class="share-card-logo-wrap"><img class="${s.class || ''}" src="${v.url}" style="width:${s.width || 360}px;" crossorigin="anonymous" /></div>`;
        },
        text(el) {
            const raw = values[el.key] || '';
            if (el.key === 'answer') console.log('[shareCard] buildShareCard answer raw:', raw.substring(0, 200));
            if (!raw) return '';
            const val = raw.replace(/\n/g, '<br>');
            const s = el.style || {};
            const isAnswer = el.key === 'answer';
            let fontSize = isAnswer
                ? (style.main_text?.font_size || s.font_size || 52)
                : (s.font_size || 28);
            if (isAnswer) fontSize = scaleFontToFit(raw, fontSize);
            // Build inline style: only answer gets font-family from preset;
            // other elements inherit from the outer .share-card wrapper.
            const parts = [
                isAnswer ? `font-family:${fontFamily}` : '',
                `font-size:${fontSize}px`,
                s.font_weight ? `font-weight:${s.font_weight}` : '',
                s.font_style ? `font-style:${s.font_style}` : '',
                s.opacity ? `opacity:${s.opacity}` : '',
                s.line_height ? `line-height:${s.line_height}` : '',
                s.flex ? `flex:${s.flex}` : '',
            ].filter(Boolean).join(';');
            return `<p class="${s.class || ''}" style="${parts}">${val}</p>`;
        },
        divider() {
            return '<div class="share-card-divider"></div>';
        },
    };

    const html = elements.map(el => (renderers[el.type] || (() => ''))(el)).join('');

    const bgImageHtml = bgImage
        ? `<img class="share-card-bg-img" src="${bgImage}" crossorigin="anonymous" />`
        : '';

    return `
        <div class="share-card" style="
            width:${width}px;height:${height}px;
            background-color:${bgColor};
            font-family:${fontFamily};
            color:${txtColor};
        ">
            <div class="share-card-bg"></div>
            ${bgImageHtml}
            ${html}
        </div>
    `;
}

/**
 * Upload generated image blob to backend for permanent storage.
 */
async function uploadShareImage(blob) {
    try {
        const formData = new FormData();
        formData.append('action', growtype_chat_ajax.generate_share_content);
        formData.append('nonce', growtype_chat_ajax.nonce);
        formData.append('image', blob, 'share.png');
        formData.append('text', window.currentShareData?.values?.answer || '');

        const response = await fetch(growtype_chat_ajax.url, {
            method: 'POST',
            body: formData,
        });

        const result = await response.json();

        if (result.success && result.data?.permanent_url) {
            window.currentSharePermanentUrl = result.data.permanent_url;
        }
    } catch (err) {
        console.warn('Failed to upload share image to server:', err);
    }
}

/**
 * Render style selector options from backend styles array
 */
function renderStyleOptions() {
    const styles = growtype_chat_ajax?.share_modal_details?.styles || [];

    if (styles.length === 0) {
        $('.style-selector').hide();
        return;
    }

    const $container = $('.style-options');
    $container.empty();
    const data = window.currentShareData || {};

    styles.forEach((style) => {
        const $btn = $('<button>')
            .addClass('style-option')
            .text(style.name || style.label || 'Style')
            .attr('data-style-index', styles.indexOf(style));

        if (data.style && data.style === style) {
            $btn.addClass('active');
        }

        $btn.on('click', function () {
            onStyleSelect(style);
        });

        $container.append($btn);
    });

    if (!data.style && styles.length > 0) {
        data.style = styles[0];
        $container.find('.style-option').first().addClass('active');
    }

    $('.style-selector').show();
}

/**
 * Handle style selection - update active state and regenerate preview
 */
function onStyleSelect(style) {
    const data = window.currentShareData || {};
    data.style = style;

    // Update active state
    $('.style-option').removeClass('active');
    const styles = growtype_chat_ajax?.share_modal_details?.styles || [];
    $('.style-option[data-style-index]').each(function () {
        const idx = parseInt($(this).attr('data-style-index'));
        if (styles[idx] === style) {
            $(this).addClass('active');
        }
    });

    // Regenerate preview with new style
    $('.generation-status').show();
    $('.image-preview-container').hide();
    $('.social-icons-grid').hide();
    $('.style-selector').hide();

    generateAndShowVideo();
}

/**
 * Handle social share button clicks
 */
function handleSocialShare(platform) {
    const imageUrl = window.currentSharePermanentUrl || window.currentShareImageUrl;

    if (!imageUrl) {
        alert('Image not ready. Please wait for generation to complete.');
        return;
    }

    // Handle platform-specific sharing
    switch (platform) {
        case 'tiktok':
            shareToTikTok(imageUrl);
            break;
        case 'instagram':
            shareToInstagram(imageUrl);
            break;
        case 'twitter':
            shareToTwitter(imageUrl);
            break;
        case 'facebook':
            shareToFacebook(imageUrl);
            break;
        case 'download':
            downloadImage(imageUrl);
            break;
    }
}

/**
 * Download image file
 */
function downloadImage(imageUrl) {
    const a = document.createElement('a');
    a.href = imageUrl;

    const siteName = window.location.hostname.replace('www.', '').split('.')[0];
    // Use JPEG extension when we generated a JPEG blob
    const isJpeg = window.currentShareBlob?.type === 'image/jpeg';
    a.download = `${siteName}-share-${Date.now()}.${isJpeg ? 'jpg' : 'png'}`;

    // For remote URLs, use fetch + blob to force download
    if (imageUrl.startsWith('http')) {
        fetch(imageUrl)
            .then(r => r.blob())
            .then(blob => {
                a.href = URL.createObjectURL(blob);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(a.href);
            });
        return;
    }

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

/**
 * Get share text from canonical data structure.
 */
function getShareText() {
    const d = window.currentShareData || {};
    return (d.values?.answer) || (d.values?.intro_message) || 'Check out this!';
}

/**
 * Inject modal styles
 */
function shareToTwitter(imageUrl) {
    const text = encodeURIComponent(getShareText());
    const url = encodeURIComponent(window.location.href);
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank');
}

/**
 * Share to Facebook via sharer URL
 */
function shareToFacebook(imageUrl) {
    const url = encodeURIComponent(window.location.href);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
}

/**
 * Share to TikTok
 *
 * Mobile: Attempts to open TikTok app via deep link (tiktok://).
 * Falls back to Web Share API, then to downloading the video.
 *
 * Desktop: Opens TikTok's upload page in a new tab + downloads the video.
 */
async function shareToTikTok(imageUrl) {
    const text = getShareText();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
        // 1. Attempt to open TikTok app via deep link
        window.location.href = 'tiktok://';

        // 2. Fallback: download the image
        setTimeout(() => downloadImage(imageUrl), 800);
        return;
    }

    // Desktop: Open TikTok upload page in new tab
    window.open('https://www.tiktok.com/upload/', '_blank');

    // Also trigger download
    setTimeout(() => downloadImage(imageUrl), 500);
}

/**
 * Share to Instagram
 */
async function shareToInstagram(imageUrl) {
    const text = getShareText();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // On mobile, try native share sheet (shows Instagram app if installed)
    if (isMobile && navigator.share) {
        try {
            // Fetch the image as a blob for sharing
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const file = new File([blob], 'share.png', { type: 'image/png' });

            await navigator.share({
                files: [file],
                title: text,
            });
            return;
        } catch (err) {
            console.log('Instagram share:', err.name);
        }
    }

    // Fallback: download image
    downloadImage(imageUrl);
}

/**
 * Inject modal styles
 */
function injectModalStyles() {
    if ($('#socialShareModalStyles').length > 0) {
        return;
    }

    const styles = `
        <style id="socialShareModalStyles">
            .social-share-modal {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 10000;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .social-share-overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.7);
                backdrop-filter: blur(5px);
            }

            .social-share-content {
                position: relative;
                background: white;
                border-radius: 20px;
                max-width: 500px;
                width: 90%;
                max-height: 90vh;
                overflow-y: auto;
                box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
                animation: slideUp 0.3s ease-out;
            }

            @keyframes slideUp {
                from {
                    opacity: 0;
                    transform: translateY(50px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            .social-share-header {
                padding: 15px 30px;
                border-bottom: 1px solid #e0e0e0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: linear-gradient(135deg, var(--gc-main-color, #ff9000) 0%, color-mix(in srgb, var(--gc-main-color, #ff9000) 80%, #000) 100%);
                border-radius: 20px 20px 0 0;
            }

            .social-share-header h3 {
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: white;
            }

            .social-share-close {
                background: rgba(255, 255, 255, 0.2);
                border: none;
                color: white;
                font-size: 32px;
                cursor: pointer;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s ease;
                line-height: 1;
                padding: 0;
            }

            .social-share-close:hover {
                background: rgba(255, 255, 255, 0.3);
                transform: rotate(90deg);
            }

            .social-share-body {
                padding: 30px;
                text-align: center;
            }

            .video-container {
                display: none;
            }

            .image-preview-container {
                margin-bottom: 20px;
                display: flex;
                justify-content: center;
            }

            .image-preview-container img {
                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
            }

            .style-selector {
                margin-bottom: 15px;
            }

            .style-selector label {
                display: block;
                font-size: 13px;
                font-weight: 600;
                color: #666;
                margin-bottom: 8px;
                text-align: left;
            }

            .style-options {
                display: flex;
                gap: 10px;
                flex-wrap: wrap;
            }

            .style-option {
                padding: 8px 16px;
                border: 2px solid #ddd;
                border-radius: 8px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 600;
                transition: all 0.2s ease;
                background: #f9f9f9;
                color: #444;
            }

            .style-option:hover {
                border-color: var(--gc-main-color, #ff9000);
                color: var(--gc-main-color, #ff9000);
            }

            .style-option.active {
                background: var(--gc-main-color, #ff9000);
                color: white;
                border-color: var(--gc-main-color, #ff9000);
            }

            .social-icons-grid {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 15px;
                margin-top: 20px;
            }

            .social-icons-grid.single-button {
                grid-template-columns: 1fr;
            }

            .social-icon-btn {
                background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
                border: 2px solid transparent;
                border-radius: 10px;
                padding: 12px 8px;
                cursor: pointer;
                transition: all 0.3s ease;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 4px;
                font-size: 11px;
                font-weight: 600;
                color: #333;
            }

            .social-icon-btn:hover {
                transform: translateY(-3px);
                box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
                border-color: var(--gc-main-color, #ff9000);
            }

            .social-icon-btn[data-platform="tiktok"]:hover {
                background: linear-gradient(135deg, #000000 0%, #ee1d52 100%);
                color: white;
            }

            .social-icon-btn[data-platform="instagram"]:hover {
                background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
                color: white;
            }

            .social-icon-btn[data-platform="twitter"]:hover {
                background: linear-gradient(135deg, #1DA1F2 0%, #0d8bd9 100%);
                color: white;
            }

            .social-icon-btn[data-platform="facebook"]:hover {
                background: linear-gradient(135deg, #1877f2 0%, #0d65d9 100%);
                color: white;
            }

            .social-icon-btn[data-platform="download"]:hover {
                background: linear-gradient(135deg, var(--gc-main-color, #ff9000) 0%, color-mix(in srgb, var(--gc-main-color, #ff9000) 80%, #000) 100%);
                color: white;
            }

            .social-icon-btn svg {
                width: 20px;
                height: 20px;
            }

            .generation-status {
                text-align: center;
                padding: 40px 20px;
            }

            .generation-status p {
                margin-top: 20px;
                color: var(--gc-main-color, #ff9000);
                font-weight: 600;
                font-size: 16px;
            }

            .spinner {
                border: 4px solid #f3f3f3;
                border-top-color: var(--gc-main-color, #ff9000);
                border-radius: 50%;
                width: 50px;
                height: 50px;
                animation: spin 1s linear infinite;
                margin: 0 auto;
            }

            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }

            @media (max-width: 640px) {
                .social-share-content {
                    width: 95%;
                    max-width: none;
                }

                .social-icons-grid {
                    grid-template-columns: repeat(3, 1fr);
                }

                .social-share-header h3 {
                    font-size: 20px;
                }

                .social-icon-btn {
                    padding: 12px 8px;
                }

                .image-preview-container {
                max-width:220px;
                margin:auto;
            }
            }
            }
        </style>
    `;

    $('head').append(styles);
}

// Expose key functions globally for the share designer page
window.initializeSocialShareModal = initializeSocialShareModal;
window.showSocialShareModal = showSocialShareModal;
window.generateAndShowVideo = generateAndShowVideo;
window.buildShareCard = buildShareCard;

/**
 * Internal: capture element to canvas (shared by all capture functions).
 */
async function _captureCanvas(element, options = {}) {
    // Strip blob-only options before passing to html2canvas
    const { mimeType, quality, ...canvasOptions } = options;
    return html2canvas(element, {
        scale: canvasOptions.scale || 1,
        useCORS: true,
        allowTaint: true,
        backgroundColor: canvasOptions.backgroundColor || null,
        ...canvasOptions,
    });
}

/**
 * Capture an element to a data URL.
 */
window.captureElementToDataUrl = async function (element, options = {}) {
    const { mimeType, quality, ...rest } = options;
    const canvas = await _captureCanvas(element, rest);
    return canvas.toDataURL(mimeType || 'image/png');
};

/**
 * Capture an element to a Blob.
 * Default: PNG. Pass { mimeType: 'image/jpeg', quality: 0.92 } for smaller files.
 */
window.captureElementToBlob = async function (element, options = {}) {
    const { mimeType, quality, ...rest } = options;
    const canvas = await _captureCanvas(element, rest);
    return new Promise(resolve => canvas.toBlob(resolve, mimeType || 'image/png', quality || 0.95));
};

// Inject share card CSS once (used by both designer page and production modal)
(function injectShareCardCss() {
    if (document.getElementById('shareCardStyles')) return;
    const style = document.createElement('style');
    style.id = 'shareCardStyles';
    style.textContent = `
        .share-card {
            width: 1080px; height: 1920px;
            display: flex; flex-direction: column;
            align-items: center;
            padding: 0; box-sizing: border-box;
            position: relative; overflow: hidden; text-align: center;
        }

        /* Depth overlay — works with any background color */
        .share-card-bg {
            position: absolute; inset: 0; pointer-events: none; z-index: 0;
            background:
                radial-gradient(ellipse 80% 55% at 50% 25%, rgba(255,255,255,0.15) 0%, transparent 60%),
                radial-gradient(ellipse 70% 35% at 50% 90%, rgba(0,0,0,0.12) 0%, transparent 60%);
        }

        /* Background image — rendered as img for reliable html2canvas capture */
        .share-card-bg-img {
            position: absolute; inset: 0; z-index: 0;
            width: 100%; height: 100%;
            object-fit: contain;
            opacity: 0.1;
            pointer-events: none;
        }
        .share-card > :not(.share-card-bg):not(.share-card-bg-img) { position: relative; z-index: 1; }

        /* ── Header section ── */
        .share-card-logo-wrap {
            padding: 100px 100px 0;
            flex-shrink: 0;
        }
        .share-card-logo {
            width: 340px; height: auto;
            filter: drop-shadow(0 2px 6px rgba(0,0,0,0.15));
        }

        .share-card-title {
            font-size: 46px; font-weight: 600;
            opacity: 0.8; letter-spacing: -0.01em;
            margin: 70px 100px 0;
            line-height: 1.2;
            flex-shrink: 0;
        }

        /* ── Body section ── */
        .share-card-intro {
            font-size: 36px; opacity: 0.6; font-style: italic;
            margin: 40px 100px 0;
            max-width: 860px;
            flex-shrink: 0;
        }

        .share-card-answer {
            font-weight: 700; line-height: 1.25;
            margin: 50px 100px;
            max-width: 880px;
            word-wrap: break-word;
            flex: 1 1 auto;
        }

        /* ── Footer section ── */
        .share-card-divider {
            width: 60px; height: 3px;
            background: currentColor;
            opacity: 0.25;
            border-radius: 2px;
            margin: 0 auto 30px;
            flex-shrink: 0;
        }

        .share-card-outro {
            font-size: 46px; font-weight: 700;
            margin: 0 100px 16px;
            letter-spacing: -0.02em; opacity: 0.9;
        }
        .share-card-domain {
            font-size: 28px; font-weight: 500;
            opacity: 0.5;
            margin: 0 100px 100px;
            letter-spacing: 0.03em; text-transform: lowercase;
        }

        /* Legacy / optional */
        .share-card-char {
            width: 420px; height: 420px; border-radius: 50%; overflow: hidden;
            border: 6px solid currentColor;
            border-color: rgba(255,255,255,0.25);
            margin: 60px 0 40px;
            flex-shrink: 0;
            box-shadow: 0 20px 50px rgba(0,0,0,0.2);
        }
        .share-card-char img { width: 100%; height: 100%; object-fit: cover; }
    `;
    document.head.appendChild(style);
})();
